import { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Switch,
  Avatar,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";

//Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
// import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_WAREHOUSE, UPDATE_ISUSE_STATUS } from "../Schema/Warehouse";
import EmptyData from "../Components/Include/EmptyData";
import CreateIcon from "../Assets/create-icon.svg";
import WarehouseForm from "../Components/Warehouse/WarehouseForm"
import WarehouseAction from "../Components/Warehouse/WarehouseAction"
import { AuthContext } from "../Context/AuthContext";

export default function Warehouse() {
  const { setAlert } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // Switch
  const [status, setStatus] = useState("All");

  const { refetch } = useQuery(GET_WAREHOUSE, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
      isUse: status === "All" ? null : status,
    },
    onCompleted: ({ getWarehouse }) => {
      setTableData(getWarehouse);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  // const handleLimit = (e) => {
  //   setLimit(e.target.value);
  //   setPage(1);
  // };

  const [updateWarehouseIsUse] = useMutation(UPDATE_ISUSE_STATUS, {
    onCompleted: ({ updateWarehouseIsUse }) => {
      if (updateWarehouseIsUse?.status) {
        setAlert(true, "success", updateWarehouseIsUse?.message);
      } else {
        setAlert(true, "error", updateWarehouseIsUse?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateWarehouseIsUse({
      variables: {
        id: id,
        isUse: status
      }
    })
  }

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ឃ្លាំងទំនិញ</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះឃ្លាំងទំនិញ"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select value={status} onChange={(e) => setStatus(e.target.value)}>
                <MenuItem value="All">
                  ទាំងអស់
                </MenuItem>
                <MenuItem value={true}>
                  ប្រើប្រាស់
                </MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>

              </Select>
            </FormControl>
          </Grid>


          <Grid item xs={12} sm={4} md={4} lg={6} xl={7.2}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <WarehouseForm
              dialogTitle="Create"
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="5%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="20%">
                ឈ្មោះឃ្លាំង
              </TableCell>
              <TableCell className="header-title" width="20%">
                ទីតាំង
              </TableCell>
              <TableCell className="header-title" width="20%">
                កំណត់សម្គាល់
              </TableCell>
              <TableCell className="header-title" align="center" width="10%">
                ស្ថានភាព
              </TableCell>

              <TableCell className="header-title-end" width="20%"></TableCell>
            </TableHead>


            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={6} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={6} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      // console.log("ROW", row,)
                      return (
                        <TableRow className="body-row"
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell">
                            <Stack direction="row" spacing={1}>
                              <Avatar
                                sx={{ width: 40, height: 40 }}
                                alt={row?.lastName}
                                src={row?.userProfile}
                              />
                              <Stack direction="column" justifyContent="center">
                                <Typography
                                  className="member-name"
                                >
                                  {row?.warehouseName}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                          <TableCell className="body-cell">
                            <Typography
                              className="member-name"
                            >
                              {row?.location}
                            </Typography>
                          </TableCell>


                          <TableCell className="body-cell" >

                            <Typography
                              className="member-name"
                            >
                              {row?.remark}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            <Box>
                              <Switch
                                checked={row?.isUse}
                                onChange={() => handleUpdateStatus(row?._id, !row?.isUse)}
                              />
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <WarehouseAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}

